import { createSlice } from '@reduxjs/toolkit';

import type { TentarDeNovoState } from '../../types/tentarDeNovo';
import { fetchExecucoesEmErro, tentarDeNovo } from './actions';

const initialState: TentarDeNovoState = {
  processoId: null,
  execucoes: [],
  carregando: false,
  erroCarregamento: null,
  enviando: false,
  erro: null,
  resultado: null,
};

const tentarDeNovoSlice = createSlice({
  name: 'secretariaArbitralTentarDeNovo',
  initialState,
  reducers: {
    /** Ao abrir o diálogo: recusa e resultado da abertura anterior não valem para esta. */
    limparTentarDeNovo(state) {
      state.erro = null;
      state.resultado = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchExecucoesEmErro.pending, (state, action) => {
        state.carregando = true;
        state.erroCarregamento = null;
        // Outro processo: a lista anterior sai já, para o diálogo não oferecer a execução dele.
        if (state.processoId !== action.meta.arg) {
          state.processoId = action.meta.arg;
          state.execucoes = [];
        }
      })
      .addCase(fetchExecucoesEmErro.fulfilled, (state, action) => {
        if (state.processoId !== action.meta.arg) return;
        state.carregando = false;
        state.execucoes = action.payload;
      })
      .addCase(fetchExecucoesEmErro.rejected, (state, action) => {
        if (state.processoId !== action.meta.arg) return;
        state.carregando = false;
        state.erroCarregamento = action.payload ?? 'Erro ao carregar a etapa que falhou';
      })
      .addCase(tentarDeNovo.pending, (state) => {
        state.enviando = true;
        state.erro = null;
        state.resultado = null;
      })
      .addCase(tentarDeNovo.fulfilled, (state, action) => {
        state.enviando = false;
        state.resultado = action.payload;
      })
      .addCase(tentarDeNovo.rejected, (state, action) => {
        state.enviando = false;
        state.erro = action.payload ?? 'Erro ao tentar de novo';
      });
  },
});

export const { limparTentarDeNovo } = tentarDeNovoSlice.actions;
export const secretariaArbitralTentarDeNovoReducer = tentarDeNovoSlice.reducer;
